// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'


// Vuetify
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { en, fr, es } from 'vuetify/locale'

import { currentLocale } from '@/i18n/index.js'

export default createVuetify(
  { 
    components, 
    directives,
    theme: {
      defaultTheme: 'light',
    },
    // Vuetify's own text (table footers, pagination, date pickers, "No data available")
    // follows the browser language with the rest of the portal.
    locale: {
      locale: currentLocale(),
      fallback: 'en',
      messages: { en, fr, es },
    },
  }
)
